module.exports = __webpack_public_path__ + "static/media/iCiel-Gotham.022af2f6.ttf";